/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Endpoint_Provider_BlockedInputs */

const en_endpoint_provider_blocked = /** @type {(inputs: Endpoint_Provider_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} blocked`)
};

const zh_hans1_endpoint_provider_blocked = /** @type {(inputs: Endpoint_Provider_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} 被拦截`)
};

const pt_br2_endpoint_provider_blocked = /** @type {(inputs: Endpoint_Provider_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} bloqueado`)
};

const es_endpoint_provider_blocked = /** @type {(inputs: Endpoint_Provider_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} bloqueado`)
};

const fr_endpoint_provider_blocked = /** @type {(inputs: Endpoint_Provider_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} bloqués`)
};

const de_endpoint_provider_blocked = /** @type {(inputs: Endpoint_Provider_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} blockiert`)
};

const ru_endpoint_provider_blocked = /** @type {(inputs: Endpoint_Provider_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Заблокировано: ${i?.value}`)
};

const it_endpoint_provider_blocked = /** @type {(inputs: Endpoint_Provider_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} bloccate`)
};

/**
* | output |
* | --- |
* | "{value} blocked" |
*
* @param {Endpoint_Provider_BlockedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_provider_blocked = /** @type {((inputs: Endpoint_Provider_BlockedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Provider_BlockedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_provider_blocked(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_provider_blocked(inputs)
	if (locale === "es") return es_endpoint_provider_blocked(inputs)
	if (locale === "fr") return fr_endpoint_provider_blocked(inputs)
	if (locale === "de") return de_endpoint_provider_blocked(inputs)
	if (locale === "ru") return ru_endpoint_provider_blocked(inputs)
	if (locale === "it") return it_endpoint_provider_blocked(inputs)
	return en_endpoint_provider_blocked(inputs)
});